import useSafeState from '../../utils/safe-state';
import React, {FC, ReactElement, ReactNode, useEffect} from 'react';
import {Form, Row, Col, Input, Button, message, Switch, InputNumber, Select, Image, Popconfirm} from 'antd';
import {useAxios} from '../../utils/hooks';
import {AxiosResponse} from "axios";
import {Trans} from "@lingui/macro";
import {antdContext} from "../../utils/antdContext";
import StockModel from "../../models/dto/stock-model";
import {SelectType} from "#/interfaces/SelectType";
import {BackendFile} from "#/interfaces/BackendFile";
import {DeleteTwoTone, InboxOutlined, QuestionCircleOutlined, WarningOutlined} from "@ant-design/icons/lib";
import Dragger from "antd/lib/upload/Dragger";
import {UploadFile} from "antd/es/upload/interface";

interface Interface {
    data?: any;
    mode?: "Edit" | "Add new" | "Photo";
    onClose?: () => void;
}

const StockForm  = (props: Interface) => {

    const [loading, setLoading] = useSafeState(false);
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "")
    const config = {headers: {'Content-Type': 'application/json'}};
    const [productAutoCompleteOptions,setProductAutoCompleteOptions] = useSafeState<any[]>([]);
    const [slotAutoCompleteOptions,setSlotAutoCompleteOptions] = useSafeState<any[]>([]);
    const [backendFiles, setBackendFiles] = useSafeState<Array<ProductImage>>([]);
    const [orders, setOrders] = useSafeState<Array<any>>([]);
    const [fileList, setFileList] = useSafeState<Array<any>>([]);

    const data = props.data || {};
    const folderName: string = data.product + '_' + (data.lotNumber ? data.lotNumber : '');
    const [form] = Form.useForm();

    let isEditMode = false;

    useEffect(() => {

        form.resetFields();

        if (props.mode === "Edit") {

            let fieldsValues = [];
            for (const [key, value] of Object.entries(data)) {
                fieldsValues.push({name: key, value: value});
            }
            form.setFields(fieldsValues);

            isEditMode = true;
        } else if (props.mode === "Add new") {
            isEditMode = false;
        } else if (props.mode === "Photo") {
            getImages(props.data['product'], props.data['lotNumber']);
        }

        getSlotData();
        getProductData();
    }, [])



    const getImages = (productCode: String, lotNumber: String) => {

        console.log(productCode, lotNumber);

        if(!axiosInstance.current){
            return;
        }

        axiosInstance.current.get('/resource/documents/get-all-by-product-code-and-lot-no?productCode=' + productCode + '&lotNo=' + (lotNumber ? lotNumber : ""))
            .then(function (response: AxiosResponse<any>) {
                if (Array.isArray(response.data)) {

                    let imgList: ProductImage[] = [];

                    response.data.forEach(value => {

                        imgList.push(
                            {
                                productCode: value.productCode,
                                lotNumber : value.lotNumber,
                                id: value.id,
                                folder: value.folder,
                                fileName: value.fileName
                            }
                        );
                    });
                    setBackendFiles(imgList);
                }
            })
            .catch(function (error: any) {
                console.log(error);//TODO::EndIt
            });
    }

    const getSlotData = () => {

        if(!axiosInstance.current){
            return;
        }

        axiosInstance.current.get('/resource/slots')
            .then(function (response: AxiosResponse<any>) {
                if (Array.isArray(response.data)) {
                    let sizeArray: Array<SelectType> = [];
                    response.data.forEach(value => {

                        const label = value.rack + ':' + value.row + ':' + value.col;
                        const val = value.id;

                        sizeArray.push(
                            {
                                label: label,
                                value: val,
                            }
                        )
                    });
                    setSlotAutoCompleteOptions(sizeArray);
                }
            })
            .catch(function (error: any) {
                console.log(error);//TODO::EndIt
            });
    };
    const getProductData = () => {

        if(!axiosInstance.current){
            return;
        }

        axiosInstance.current.get('/resource/products')
            .then(function (response: AxiosResponse<any>) {
                if (Array.isArray(response.data)) {
                    let sizeArray: Array<SelectType> = [];
                    response.data.forEach(value => {

                        const label = value.name;
                        const val = value.code;

                        sizeArray.push(
                            {
                                label: label,
                                value: val,
                            }
                        )
                    });
                    setProductAutoCompleteOptions(sizeArray);
                }
            })
            .catch(function (error: any) {
                console.log(error);//TODO::EndIt
            });
    };

    const onReset = () => {
        form.resetFields();
    };

    const IconText = ({ icon , text  } : any) => (
        <div>
            {icon}
            {text}
        </div>
    );

    type ProductImage = {
        productCode: string,
        lotNumber: string,
        fileName: string,
        folder : string,
        id : number
    }

    const removeFile = (id : number) =>
    {

        if (!axiosInstance.current) {
            return;
        }

        axiosInstance.current.delete('/resource/documents/id/'+id,)
            .then(function (response: AxiosResponse<any>)
            {
                const current  = backendFiles;

                if(response.status == 200)
                {
                    setBackendFiles(current.filter(value => value.id != id));
                    message.success(antdContext('Success delete'));
                }
                else
                {
                    message.error(antdContext('Error on delete'));
                }

            })
            .catch(function (error: any) {
                console.log(error);//TODO::EndIt
            });

    }

    const generateFiles =  (msgDoc : BackendFile[]) => {

        let fileArray: ReactElement[] = [];

        if (msgDoc == null || msgDoc.length == 0) {

            fileArray.push(  <IconText
                icon={<WarningOutlined style={{marginRight:6}}/>}
                text={<Trans>Files not found to this message</Trans>}/>);

            return fileArray;
        }

        msgDoc.forEach((value, index) => {

            fileArray.push(
                <span style={{maxHeight: 300, paddingRight: "25px", overflow: "hidden"}}>
                    <div style={{marginBottom: "10px", display: "inline-block"}}>
                        <Image
                            style={{
                                display: "block",
                                objectFit: "cover",
                                width: 100,
                                height: 100
                            }}
                            src= { process.env.REACT_APP_API_BASE_URL + '/public/file/get?folder=' + value.folder + '&filename=' + folderName + "/" + value.fileName }
                            alt={'Nincs megjeleníthető kép'}
                        />
                    </div>

                    <Popconfirm
                        onConfirm={() => removeFile(value.id)}
                        okText={<Trans>Yes</Trans>}
                        cancelText={<Trans>No</Trans>}
                        title={<Trans>Are u sure?</Trans>} icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
                        <DeleteTwoTone style = {{position: 'absolute', paddingTop: "-80px"}} twoToneColor={"red"} onClick={() => console.log("")} />
                    </Popconfirm>
                </span>);

        });

        return fileArray;
    }

    const openNotification = (status: any) => {
        if (status === "error") {
            message.error(antdContext('Hiba mentés közben')).then(r => {
                console.log(r)
            });
        } else if (status === "success") {
            message.success(antdContext('Sikeres mentés'));
        } else {
            message.info(antdContext('Ismeretlen hiba')).then(r => {
                console.log(r)
            })
        }
        if (props.onClose) {
            props.onClose();
        }
    };


    const handleEdit = () => {

        if (axiosInstance.current != null) {
            const obj = {
                id: form.getFieldValue(["id"]),
                product:{
                   code:form.getFieldValue(["product"])
                },
                slot:{
                    id:form.getFieldValue(["slot"])
                },
                quantity: form.getFieldValue(["quantity"]),
                lotNumber: form.getFieldValue(["lotNumber"]),
                version: data.version
            };
            setLoading(true);
            axiosInstance.current.put("/resource/stocks/id?id=" + form.getFieldValue(["id"]), obj,
                config).then(() => {
                openNotification("success");
                setLoading(false);

            }).catch(function (error: any) {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }
    const handleAddNew = () => {

        if (axiosInstance.current != null) {
            const obj = {
                product:{
                    code:form.getFieldValue(["product"])
                },
                slot:{
                    id:form.getFieldValue(["slot"])
                },
                quantity: form.getFieldValue(["quantity"]),
                lotNumber: form.getFieldValue(["lotNumber"])
            };
            setLoading(true);
            axiosInstance.current.post("/resource/stocks", obj, config).then(function (response: AxiosResponse<any>) {

                openNotification("success");
                setLoading(false);

            }).catch(function (error: any)
            {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }

    const uploadPropsCopy = {
        name: 'pic',
        multiple: false,
        onChange(info:any)
        {
            const { status } = info.file;

            if (status !== 'uploading') {
                console.log('uploading',info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} {<Trans>file uploaded successfully.</Trans>}`);
            } else if (status === 'error') {
                message.error(`${info.file.name} {<Trans>file upload failed.</Trans>}`);
            }
        },
        beforeUpload(file:any)
        {
            let fileList2 : Array<any> = fileList;
            fileList2.push(file);
            setFileList(fileList2);
            return false;
        },
        onRemove(file: UploadFile<any>)
        {
            let currentList : Array<UploadFile> = fileList;
            currentList = currentList.filter(value => value.name!=file.name);
            setFileList(currentList);
        }
    };

    const handlePhoto = () => {

        if(axiosInstance.current != null){
            setLoading(true);

            const formData = new FormData();
            fileList.forEach(file => {
                formData.append('files', file);
            });
            formData.append('productCode', props.data["product"]);
            formData.append('lotNumber', props.data["lotNumber"] ? props.data["lotNumber"] : "");

            axiosInstance.current.put("/resource/supplier-orders/add-files-to-order",
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
                openNotification("success");
                setLoading(false);
            }).catch(function (error :any) {
                setLoading(false);
                openNotification("error");
                console.log(error)
            });
        }
    }

    return (
        <Form id={props.mode} form={form} layout="vertical"
              onFinish={() => props.mode === "Edit" ? handleEdit() : props.mode === "Photo" ? handlePhoto() : handleAddNew()}>
            {props.mode === "Photo" ?
                <>
                    <Row gutter={24}>
                        <Col span={24}>

                            <Form.Item
                                name="fenykep"
                                children={<Dragger {...uploadPropsCopy}>
                                    <div></div>
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text"><Trans>Click or drag file to this area to upload</Trans></p>
                                </Dragger>}
                            />

                        </Col>
                    </Row>
                    <Row style={{marginBottom:10}} gutter={24}>
                        <Col span={24}>
                            {generateFiles(backendFiles)}
                        </Col>
                    </Row>
                    <Button loading={loading} htmlType="button" type="primary" onClick={() => form.submit()}>
                        <Trans>Mentés</Trans>
                    </Button>
                </>
                :
            <>
                <Row gutter={24}>
                    <Col span={16}>
                        <Form.Item
                            name="product"
                            label={<Trans id={'Product'}/>}
                            children={
                                <Select
                                    notFoundContent={<Trans id={'No data'}/>}
                                    showSearch={true}
                                    style={{ width: '100%' }}
                                    placeholder={<Trans id={'Select a product'}></Trans>}
                                    options={productAutoCompleteOptions}
                                />
                            }
                            rules={[{
                                required: true,
                                message: <Trans>Please choose</Trans>
                            }]}
                        />
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="lotNumber"
                            label={<Trans>Lot number</Trans>}
                            children={<Input disabled={false}/>}
                            rules={[{
                                type: "string",
                                required: false,
                                message: <Trans>Please type a lot number</Trans>
                            }]}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name="quantity"
                            label={<Trans>Quantity</Trans>}
                            children={<InputNumber disabled={false} style={{ width: '100%' }}/>}
                            rules={[{
                                type: "number",
                                required: true,
                                message: <Trans>Please type a quantity</Trans>
                            }]}
                        />
                    </Col>
                    <Col span={16}>
                        <Form.Item
                            name="slot"
                            label={<Trans id={'Slot'}/>}
                            children={
                                <Select
                                    notFoundContent={<Trans id={'No data'}/>}
                                    showSearch={true}
                                    style={{ width: '100%' }}
                                    placeholder={<Trans id={'Select a slot'}></Trans>}
                                    options={slotAutoCompleteOptions}
                                />
                            }
                            rules={[{
                                required: true,
                                message: <Trans>Please choose</Trans>
                            }]}
                        />
                    </Col>
                </Row>
            </>
            }
            {props.mode === "Edit" ?
                <Button loading={loading} htmlType="button" type="primary" onClick={() => form.submit()}>
                    <Trans>Mentés</Trans>
                </Button>
                :
                props.mode === "Add new" ?
                    <>
                        <Button htmlType="button" style={{marginRight: 8}} onClick={() => onReset()}>
                            <Trans>Vissza</Trans>
                        </Button>
                        <Button loading={loading} htmlType="button" type="primary" style={{marginRight: 8}}
                                onClick={() => form.submit()}>
                            <Trans>Save</Trans>
                        </Button>
                    </>
                    :
                    <></>
            }
        </Form>
    );

}
export default StockForm;
